import React from "react";
import { LeafBranch, FloralCircle, DotCluster, SmallSprig, ThinArc, Blob } from "../components/Decorations";
import { Instagram, MessageCircle, Mail, ChevronRight, Globe, CalendarHeart } from "lucide-react";
import andrea2Bg from "../assets/andrea2.jpg";

const links = [
  {
    href: "https://www.instagram.com/psico.andreaml/",
    icon: <Instagram size={19} strokeWidth={1.6} />,
    label: "Instagram",
    sub: "@psico.andreaml",
  },
  {
    href: "https://wa.me/56995081402",
    icon: <MessageCircle size={19} strokeWidth={1.6} />,
    label: "WhatsApp",
    sub: "Escríbeme directamente",
  },
  {
    href: "https://www.doctoralia.cl/andrea-martinez-lillo/psicologo/quilpue",
    icon: <span className="font-bold text-[14px] leading-none tracking-tight">Dr</span>,
    label: "Doctoralia",
    sub: "Reseñas y agenda online",
  },
  {
    href: "mailto:psandreamartinezlillo@gmail.com",
    icon: <Mail size={19} strokeWidth={1.6} />,
    label: "Correo electrónico",
    sub: "psandreamartinezlillo@gmail.com",
  },
  {
    href: "https://www.psicoandreamartinez.cl",
    icon: <Globe size={19} strokeWidth={1.6} />,
    label: "Sitio web",
    sub: "www.psicoandreamartinez.cl",
  },
];

const Redes = () => (
  <div
    className="min-h-screen flex flex-col items-center justify-center relative overflow-hidden px-5 py-4"
    style={{ background: "linear-gradient(160deg, #EDD8C6 0%, #F5EDE3 55%, #EFE3D2 100%)" }}
  >
    {/* Decoraciones botánicas — fondo completo */}
    {/* Blobs difusos */}
    <Blob className="w-[380px] h-[440px] -left-28 top-0 opacity-40 decor-drift" />
    <Blob className="w-[300px] h-[360px] -right-20 bottom-10 opacity-30 decor-drift" style={{ animationDelay: "4s" }} />

    {/* Ramas botánicas en las 4 esquinas */}
    <LeafBranch className="absolute left-0 top-0 opacity-[0.28] decor-sway" style={{ height: 380 }} />
    <LeafBranch className="absolute left-0 bottom-0 opacity-[0.18] decor-sway" style={{ animationDelay: "1.2s", height: 280 }} />
    <LeafBranch className="absolute right-0 top-0 opacity-[0.20] decor-sway" flip style={{ animationDelay: "2s", height: 360 }} />
    <LeafBranch className="absolute right-0 bottom-0 opacity-[0.15] decor-sway" flip style={{ animationDelay: "3s", height: 250 }} />

    {/* Círculos florales */}
    <FloralCircle className="absolute left-[4%] bottom-[10%] opacity-[0.22] decor-spin" style={{ width: 120, height: 120 }} />
    <FloralCircle className="absolute right-[5%] top-[8%] opacity-[0.18] decor-spin" style={{ animationDelay: "5s", width: 100, height: 100 }} />
    <FloralCircle className="absolute left-[8%] top-[38%] opacity-[0.14] decor-spin" style={{ animationDelay: "2.5s", width: 70, height: 70 }} />
    <FloralCircle className="absolute right-[7%] bottom-[35%] opacity-[0.13] decor-spin" style={{ animationDelay: "8s", width: 65, height: 65 }} />

    {/* Clusters de puntos */}
    <DotCluster className="absolute right-[12%] bottom-[16%] opacity-[0.35] decor-pulse" />
    <DotCluster className="absolute left-[15%] top-[12%] opacity-[0.28] decor-pulse" style={{ animationDelay: "1s" }} />
    <DotCluster className="absolute left-[20%] bottom-[38%] opacity-[0.22] decor-pulse" style={{ animationDelay: "2s" }} />
    <DotCluster className="absolute right-[18%] top-[42%] opacity-[0.20] decor-pulse" style={{ animationDelay: "0.5s" }} />

    {/* Arcos finos */}
    <ThinArc className="absolute left-[35%] top-[3%] opacity-[0.18]" />
    <ThinArc className="absolute right-[2%] top-[55%] opacity-[0.14]" style={{ transform: "rotate(90deg)" }} />
    <ThinArc className="absolute left-[1%] top-[52%] opacity-[0.12]" style={{ transform: "rotate(-30deg)" }} />

    {/* Sprigs pequeños dispersos */}
    <SmallSprig className="absolute right-[22%] top-[18%] opacity-[0.22]" />
    <SmallSprig className="absolute left-[24%] bottom-[22%] opacity-[0.18]" style={{ transform: "rotate(180deg)" }} />
    <SmallSprig className="absolute left-[38%] top-[88%] opacity-[0.16]" />
    <SmallSprig className="absolute right-[30%] top-[6%] opacity-[0.15]" style={{ transform: "rotate(15deg)" }} />

    {/* Contenido central */}
    <div className="relative z-10 w-full max-w-[360px] flex flex-col items-center fade-up">

      {/* Avatar orgánico */}
      <div
        className="mb-2 shrink-0"
        style={{
          width: 64, height: 64,
          borderRadius: "62% 38% 56% 44% / 52% 58% 42% 48%",
          overflow: "hidden",
          boxShadow: "0 8px 22px -8px rgba(59,42,26,0.28)",
        }}
      >
        <img src={andrea2Bg} alt="Psicóloga Andrea Martínez"
          style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center top" }} />
      </div>

      {/* Identidad */}
      <p className="eyebrow mb-0.5" style={{ letterSpacing: "0.26em", fontSize: "0.6rem" }}>Psicóloga</p>
      <h1 className="font-serif-display text-[22px] leading-tight text-[var(--ink-900)] text-center mb-1">
        Andrea Martínez
      </h1>
      <p className="text-[var(--ink-500)] text-[11px] text-center leading-relaxed max-w-[240px] mb-3">
        Terapia online y presencial · Un espacio para comprenderte y sanar
      </p>

      {/* Separador diamante */}
      <div className="flex items-center gap-2.5 w-full max-w-[180px] mb-3">
        <div className="flex-1 h-[1px] rounded-full opacity-50"
          style={{ background: "linear-gradient(to right, transparent, var(--terra-400))" }} />
        <div style={{ width: 4, height: 4, background: "var(--terra-500)", transform: "rotate(45deg)", opacity: 0.65 }} />
        <div className="flex-1 h-[1px] rounded-full opacity-50"
          style={{ background: "linear-gradient(to left, transparent, var(--terra-400))" }} />
      </div>

      {/* Cards de links */}
      <div className="w-full flex flex-col gap-1.5">
        {links.map((l, i) => (
          <a
            key={i}
            href={l.href}
            target={l.href.startsWith("http") || l.href.startsWith("mailto") ? "_blank" : "_self"}
            rel="noopener noreferrer"
            className="flex items-center gap-2.5 rounded-xl px-3 py-2 group transition-all duration-200 hover:-translate-y-0.5"
            style={{
              background: "rgba(255,255,255,0.78)",
              backdropFilter: "blur(10px)",
              border: "1px solid var(--cream-200)",
              boxShadow: "0 2px 10px -5px rgba(59,42,26,0.10)",
            }}
          >
            <div
              className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0 text-[var(--terra-500)] transition-colors group-hover:bg-[var(--peach-200)]"
              style={{ background: "var(--peach-100)" }}
            >
              {l.icon}
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-[var(--ink-900)] text-[12.5px] leading-tight">{l.label}</p>
              <p className="text-[var(--ink-400)] text-[10.5px] truncate">{l.sub}</p>
            </div>
            <ChevronRight size={13} strokeWidth={2}
              className="text-[var(--ink-400)] group-hover:text-[var(--terra-500)] transition-colors shrink-0" />
          </a>
        ))}
      </div>

      {/* CTA agenda */}
      <a
        href="https://wa.me/56995081402?text=Hola%20Andrea%2C%20me%20gustar%C3%ADa%20agendar%20una%20sesi%C3%B3n"
        target="_blank" rel="noopener noreferrer"
        className="btn-pill btn-pill-primary mt-3 w-full justify-center"
        style={{ display: "flex", padding: "0.6rem 1.2rem", fontSize: "0.7rem" }}
      >
        <CalendarHeart size={13} strokeWidth={2} />
        Agenda tu primera sesión
      </a>

      {/* Footer */}
      <div className="flex items-center gap-2 mt-4 opacity-60">
        <svg width="14" height="18" viewBox="0 0 46 58" fill="none">
          <path d="M2.5 22 C2.5 10, 12 1.5, 23 1.5 C34 1.5, 43.5 10, 43.5 22 L43.5 56.5 L2.5 56.5 Z"
            stroke="#2B1F18" strokeWidth="1.4" fill="none" />
          <path d="M23 16 C23 24, 23 36, 23 44" stroke="#B8694F" strokeWidth="1.2" fill="none" strokeLinecap="round" />
          <path d="M23 22 C19 21, 16 23, 15 26 C18 27, 21 25, 23 22 Z" fill="#B8694F" opacity="0.85" />
          <path d="M23 28 C27 27, 30 29, 31 32 C28 33, 25 31, 23 28 Z" fill="#B8694F" opacity="0.85" />
          <path d="M23 34 C19 33, 16 35, 15 38 C18 39, 21 37, 23 34 Z" fill="#B8694F" opacity="0.85" />
        </svg>
        <p className="text-[var(--ink-400)] text-[10px] tracking-wide">© 2025 · Andrea Martínez · Psicóloga</p>
      </div>
    </div>
  </div>
);

export default Redes;
